var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.character)?_c('simple-dialog',{attrs:{"title":"キャラクターを編集","value":_vm.value},on:{"input":_vm.onInput}},[_c('character-editing-tabs',{attrs:{"character":_vm.character,"character-attribute-names":_vm.characterAttributeNames}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }